import { P } from 'components'
import { Button, Modal, ModalBody, Spinner } from 'reactstrap'

const ModalSellerApproveConfirm = ({
  isOpen,
  toggle,
  onConfirm,
  isLoading,
}) => {
  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpen}
      toggle={() => toggle()}
      autoFocus={false}
      data-testid="detail-transaction-modal-approve"
    >
      <ModalBody>
        <P size="medium" className="fw-semibold mb-1">
          Terima penyesuaian
        </P>
        <P size="regular" className="text-sm" color="#475467">
          Jumlah pembayaran yang Anda terima akan berubah.
        </P>
        <P size="regular" className="text-sm mb-4" color="#475467">
          Apakah Anda yakin untuk melanjutkan?
        </P>

        <div className="d-flex gap-3">
          <Button
            disabled={isLoading}
            onClick={() => toggle()}
            className="btn-cancel"
            outline
            block
            data-testid="detail-transaction-modal-approve-cancel"
          >
            Batal
          </Button>
          <Button
            disabled={isLoading}
            onClick={() => onConfirm()}
            color="primary"
            block
            data-testid="detail-transaction-modal-approve-submit"
          >
            {isLoading && (
              <Spinner
                className="me-1"
                size={'sm'}
                style={{ color: 'white' }}
              />
            )}{' '}
            Lanjutkan
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalSellerApproveConfirm
